module.exports = __webpack_public_path__ + "img/midlineExpress.b4da2e04.jpg";